import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template6',
  templateUrl: './template6.component.html',
  styleUrls: ['./template6.component.scss']
})
export class Template6Component implements OnInit {

  template3Doughnut = {
    labels: ['A','B','C'],
    datasets: [
        {
            data: [300, 50, 100],
            backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ],
            hoverBackgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ]
        }]
  }
  template3Polar = {
    datasets: [{
        data: [
            11,16,7,3,14
        ],
        backgroundColor: [
            "#FF6384",
            "#4BC0C0",
            "#FFCE56",
            "#E7E9ED",
            "#36A2EB"
        ],
        label: 'My dataset'
    }],
    labels: [
        "Red","Green","Yellow","Grey","Blue"
    ]
  }
  template3Radar = {
    labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgba(179,181,198,1)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            data: [65, 59, 90, 81, 56, 55, 40]
        },
        {
            label: 'My Second dataset',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(255,99,132,1)',
            pointBackgroundColor: 'rgba(255,99,132,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255,99,132,1)',
            data: [28, 48, 40, 19, 96, 27, 100]
        }
    ]
  }
  template1BarData = [
    {
      "id":1,
      "name":"test1",
      "code":"test1",
      "category":"test1",
      "quantity":"test1"
    },
    {
      "id":2,
      "name":"test2",
      "code":"test2",
      "category":"test2",
      "quantity":"test2"
    },
    {
      "id":3,
      "name":"test3",
      "code":"test3",
      "category":"test3",
      "quantity":"test3"
    },
    {
      "id":4,
      "name":"test4",
      "code":"test4",
      "category":"test4",
      "quantity":"test4"
    },
    {
      "id":5,
      "name":"test5",
      "code":"test5",
      "category":"test5",
      "quantity":"test5"
    },
    {
      "id":6,
      "name":"test6",
      "code":"test6",
      "category":"test6",
      "quantity":"test6"
    },
    {
      "id":7,
      "name":"test7",
      "code":"test7",
      "category":"test7",
      "quantity":"test7"
    },
  ]

  displayDoughnutDetail = false;
  selectedDoughnutData;
  selectedDoughnutLabel;

  showTable1 = true;
  showTable2 = false;
  showTable3 = false;

  constructor() { }

  ngOnInit(): void {
  }

  selectDoughnutData(event) {
    this.displayDoughnutDetail = true;
    this.selectedDoughnutData = this.template3Doughnut.datasets[event.element._datasetIndex].data[event.element._index];
    this.selectedDoughnutLabel = this.template3Doughnut.labels[event.element._index];
  }

}
